var defaultAction = function defaultAction(modal) {
  return modal.onCloseSuccess();
};
var modalsToActions = new Map();

/**
 *
 * This sets up a mock showModal function to automatically invoke a close handler
 * whenever it's called with a specific ModalComponent. After showModal is called,
 * the corresponding close handler is automatically triggered after a promise tick passes,
 * in order to match the async nature of modal open/close cycles in browsers.
 *
 * @example
 * const showModal = jest.fn();
 * const onDismiss = jest.fn();
 * const MyModalComponent = (props: ModalProps<{}>) => <div {...props} />;
 * mockShowModal(showModal, MyModalComponent, modal => modal.onDismiss());
 * showModal(<MyModalComponent onDismiss={onDismiss} />)
 * expect(onDismiss).not.toBeCalled();
 * await React.act(waitForPromises);
 * expect(onDismiss).toBeCalled();
 *
 * @returns void
 */
export function mockShowModal(showModal, ModalComponent, closeAction) {
  mockShowModalStrictMode(showModal, ModalComponent, closeAction);
}
export function mockShowModalStrictMode(showModal, ModalComponent) {
  var closeAction = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : defaultAction;
  modalsToActions.set(ModalComponent, closeAction);
  showModal.mockImplementation(function (element) {
    var action = modalsToActions.get(element.type) || defaultAction;
    simulateModalClose(element.props, action);
  });
}
export function getShownModalProps(showModal, Component) {
  var result = showModal.mock.calls.find(function (call) {
    return call[0].type === Component;
  });
  return result === null || result === void 0 ? void 0 : result[0].props;
}
export function mockFunctionModal(modal) {
  var closeAction = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : defaultAction;
  modal.mockImplementation(function (props) {
    simulateModalClose(props, closeAction);
  });
}
function simulateModalClose(props, action) {
  var fakeModal = {
    onCloseSuccess: function onCloseSuccess(value) {
      Promise.resolve().then(function () {
        if (props.onCloseSuccess) {
          props.onCloseSuccess(value);
        }
      });
    },
    onDismiss: function onDismiss() {
      Promise.resolve().then(function () {
        if (props.onDismiss) {
          props.onDismiss();
        }
      });
    }
  };
  action(fakeModal);
}